import React, { useEffect } from 'react';
import {
  getBaseUrl,
  i18n,
  storeLang,
  storeToken,
  usePostUserRegisterFcm,
} from 'core/src';
import { Routes } from './Routes';
import { createSocketIoContext } from 'react-signalr/socketio';
import { setFcm, storeFcm } from 'core/src';
import { messaging, getToken, onMessage } from './firebase';

export const SocketIOContext = createSocketIoContext();
const AppCantainer = () => {
  const { lang } = storeLang.useState();
  i18n.changeLanguage(lang);
  const { token } = storeToken.useState();
  const { fcm } = storeFcm.useState();
  const dispatch = storeFcm.useDispatch();

  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey:
            'BIPteC-4avqdWZhwUZBX4-kUgTGAeSeIkbwgOIop2mMrfbiRO84DQLnWMo_-SMILcwx_89cJ65cnkxyDZUoeuZo',
        });
        if (token) {
          dispatch(setFcm(token));
        } else {
          dispatch(setFcm(''));
        }
      } else {
        dispatch(setFcm(''));
      }
    } catch (error) {
      dispatch(setFcm(''));
    }
  };

  useEffect(() => {
    requestPermission();
  }, []);

  useEffect(() => {
    onMessage(messaging, (payload) => {
      console.log(payload, '222222');

      if (document.visibilityState === 'visible') {
        const { title, body, icon }: any = payload.notification;
        const notification = new Notification(title, { body });
        if (icon) {
          notification.onclick = () => {
            window.location.href = icon;
          };
        }
      }
    });
  }, []);

  const { mutate: fcmMutate } = usePostUserRegisterFcm();

  useEffect(() => {
    token &&
      fcmMutate({
        requestBody: {
          fcmToken: fcm,
        },
      });
  }, [token, fcmMutate, fcm]);
  return (
    <SocketIOContext.Provider
      connectEnabled={!!token}
      transports={['websocket']}
      query={{
        token: token,
      }}
      reconnection={true}
      autoConnect={true}
      automaticReconnect={true}
      accessTokenFactory={() => `Bearer ${token}`}
      dependencies={[token]}
      url={getBaseUrl()}
    >
      <Routes {...{ token }} />
    </SocketIOContext.Provider>
  );
};

export { AppCantainer };
